import {Chip} from "@mui/material";
import {OrderFlags} from "../../types/domain/orderFlags";

export interface Props {
    flags: OrderFlags[] | undefined;
}

export const AdminOrderFlags = (props: Props) => {
    const containerStyle = {
        display: "inline-block",
    };

    const tagStyle = {
        margin: "4px 0",
        fontSize: "12px",
    };

    return <div style={containerStyle}>{props.flags?.map((f) => <Chip style={tagStyle} key={f} label={f} />)}</div>;
};
